import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Hotel } from 'app/shared/model/hotel';
import { UtilService } from 'app/shared/util.service';
import { FollowupPropertiesService } from 'app/inter-chain/followup/properties/followup-properties.service';
import { canLoadData, getRequestParams, NpsResponse } from './followup-summary-widgets.utils';
import { finalize } from 'rxjs/operators';

type LoadingKey = 'validDataRate' | 'answersRate' | 'averageRating' | 'semanticIndex';

@Component({
  selector: 'mh-followup-summary-widgets',
  templateUrl: './followup-summary-widgets.component.html',
  providers: [],
  standalone: false,
})
export class FollowupSummaryWidgetsComponent implements OnChanges {
  @Input() chainFilter: Hotel[] = [];
  @Input() productId = 1;
  @Input() currentDates: { startDate?: string; endDate?: string };
  @Input() currentFilterDate: { label?: string };
  @Input() surveysReady = false;
  @Input() chain: Hotel[] = [];
  @Input() fidelityPermissions: string[] = [];

  @Output() loadingStateChange = new EventEmitter<boolean>();

  isSuperAdmin = false;
  loadingValidDataRate = false;
  loadingAnswersRate = false;
  loadingAverageRating = false;
  loadingSemanticIndex = false;

  npsData: NpsResponse | null = null;
  loadingNpsData = false;

  constructor(
    private utilService: UtilService,
    private followupPropertiesService: FollowupPropertiesService,
  ) {
    this.isSuperAdmin = this.utilService.currentUser?.superAdmin ?? false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes.chainFilter || changes.currentDates || changes.surveysReady) &&
      canLoadData(this.utilService, this.chainFilter, this.surveysReady)
    ) {
      this.loadNpsData();
    }
  }

  get isHotel(): boolean {
    return (
      !this.utilService.customerIsRetail && !this.utilService.customerIsClinic && !this.utilService.customerIsAirline
    );
  }

  get isLoadingData(): boolean {
    return (
      this.loadingValidDataRate ||
      this.loadingAnswersRate ||
      this.loadingSemanticIndex ||
      this.loadingAverageRating ||
      this.loadingNpsData
    );
  }

  onLoadingChange(value: boolean, key: LoadingKey): void {
    switch (key) {
      case 'validDataRate':
        this.loadingValidDataRate = value;
        break;
      case 'answersRate':
        this.loadingAnswersRate = value;
        break;
      case 'averageRating':
        this.loadingAverageRating = value;
        break;
      case 'semanticIndex':
        this.loadingSemanticIndex = value;
        break;
    }
    this.emitLoadingState();
  }

  private loadNpsData(): void {
    this.loadingNpsData = true;
    this.npsData = null;
    const { dates, surveyIds, customerIds, version } = getRequestParams(
      this.utilService,
      this.chainFilter,
      this.currentDates,
    );

    this.followupPropertiesService
      .getNPS(dates, customerIds, this.productId, surveyIds, version)
      .pipe(finalize(() => (this.loadingNpsData = false)))
      .subscribe({
        next: (response) => (this.npsData = response as NpsResponse),
        error: () => (this.npsData = null),
      });
  }

  private emitLoadingState(): void {
    setTimeout(() => {
      this.loadingStateChange.emit(this.isLoadingData);
    });
  }
}
